import React, { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../utils/env';

// Resolve API base URL (same logic as api.js)
const resolveDefaultApiBase = () => {
  try {
    const host = window?.location?.hostname || '';
    if (host.endsWith('sortafriends.com')) {
      return 'https://api.sortafriends.com';
    }
  } catch (_) {}
  return 'http://localhost:8000';
};

const API_BASE_URL = getApiBaseUrl(resolveDefaultApiBase());

const Health = () => {
  const [healthData, setHealthData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHealth = async () => {
      try {
        setLoading(true);
        // Call the backend /health endpoint directly without auth token
        const response = await fetch(`${API_BASE_URL}/health`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setHealthData(data);
        setError(null);
      } catch (err) {
        setError({ error: err.message });
      } finally {
        setLoading(false);
      }
    };

    fetchHealth();
  }, []);

  if (loading) {
    return null; // Return nothing while loading to avoid flash
  }

  if (error) {
    // Return error as JSON
    return (
      <pre style={{ margin: 0, padding: 0, fontFamily: 'monospace' }}>
        {JSON.stringify(error, null, 2)}
      </pre>
    );
  }

  // Return JSON response (proxied from backend)
  return (
    <pre style={{ margin: 0, padding: 0, fontFamily: 'monospace' }}>
      {JSON.stringify(healthData, null, 2)}
    </pre>
  );
};

export default Health;

